import { actions$ } from "mini-rx-store";
import { catchError, map, of, switchMap } from "rxjs";
import { ofType } from "ts-action-operators";

import { loadBvBeschluesse, loadBvSitze, loadBvSitzungen } from "./bv-actions.js";
import { bvService } from "../service/bv-service.js";
import { gremienService } from "../../gremien/service/gremien-service.js";
import { isoTag } from "../../../common/format/de-format.js";

/**
 * Sitzungen — die Grenze zwischen kommend und vergangen ist der heutige TAG.
 *
 * Sie wird hier gebildet, nicht im Dienst: Ein Dienst, der die Uhr liest, ist
 * nicht prüfbar. So bekommt er den Tag übergeben.
 */
export const loadBvSitzungenEffect = actions$.pipe(
  ofType(loadBvSitzungen.action),
  switchMap(({ payload: gremiumId }) =>
    gremienService.ladeSitzungen(gremiumId, isoTag(new Date())).pipe(
      map((sitzungen) => loadBvSitzungen.success(sitzungen)),
      catchError((err) => of(loadBvSitzungen.fail(err))),
    ),
  ),
);

export const loadBvBeschluesseEffect = actions$.pipe(
  ofType(loadBvBeschluesse.action),
  switchMap(({ payload: gremiumId }) =>
    gremienService.ladeDrucksachen(gremiumId).pipe(
      map((b) => loadBvBeschluesse.success(b)),
      catchError((err) => of(loadBvBeschluesse.fail(err))),
    ),
  ),
);

export const loadBvSitzeEffect = actions$.pipe(
  ofType(loadBvSitze.action),
  switchMap(() =>
    bvService.ladeSitzverteilung().pipe(
      map((sitze) => loadBvSitze.success(sitze)),
      catchError((err) => of(loadBvSitze.fail(err))),
    ),
  ),
);

export const bvEffects = [loadBvSitzungenEffect, loadBvBeschluesseEffect, loadBvSitzeEffect];
